<template>
  <div id="renderRegistrationModal">
    <DeviseAuth
      size="lg"
      id="renderRegistrationModal"
      :show="authModal"
      :addOn="addOn"
      :recaptchaKey="recaptchaKey"
      :termsOfServicePath="termsOfServicePath"
      :privacyPath="privacyPath"
    >
    </DeviseAuth>
  </div>
</template>

<script>
import DeviseAuth from '../components/DeviseAuth.vue';

export default {
  components: {
    DeviseAuth,
  },

  data() {
    return {
      authModal: true,
    };
  },

  props: {
    privacyPath: {
      type: String,
      required: true,
    },
    termsOfServicePath: {
      type: String,
      required: true,
    },
    addOn: {
      type: String,
    },
    eventListener: {
      type: CustomEvent,
    },
    recaptchaKey: {
      type: String,
      required: true,
    },
  },
};
</script>
